import { render, staticRenderFns } from "./PcChevronIcon.vue?vue&type=template&id=276e9a1c&scoped=true"
import script from "./PcChevronIcon.vue?vue&type=script&lang=js"
export * from "./PcChevronIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276e9a1c",
  null
  
)

export default component.exports